import { ESystemType } from '.';
import Cookies from 'js-cookie';

const settings = {
  /**
   * @description 网站标题
   */
  title: '平台',
  /**
   * @description 是否显示 tabs
   */
  showTopTabs: true,
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  tokenCookieExpires: 1,
  /**
   * @description 是否只保持一个子菜单的展开
   */
  uniqueOpened: true,
  /**
   * @description token key
   */
  TokenKey: 'PLATFORM-TOKEN',
  /**
   * @description 请求超时时间，毫秒（默认2分钟）
   */
  timeout: 1200000,
  /**
   * @description 是否显示logo
   */
  showNavLogo: true,
  /**
   * 是否显示设置的底部信息
   */
  showFooter: false,
  /**
   * 备案号
   */
  caseNumber: '苏ICP备2021042436号-1',

  /** 地址 */
  address: '江苏省南京市江宁区竹翠路1号万科都荟天地17楼',

  /** sidebar collapse storage key */
  sidebarCollapseKey: 'sidebar-collapse',
  /** 小尺寸高度分辨率边界 */
  smallHeight: 680,
  /** 端对象存储key */
  identityKey: 'IDENTITY-KEY',
  systemTypeKey: 'systemType',
  mockEnvSysTypeKey: 'mockEnvSysType',
  oemkeys: 'OEM-KEY',
  authenticatekey: 'AUTHENTICATE-KEY',
  imageEditorScriptKey: 'filerobot-image-editor',
  imageEditorScriptUrl: 'https://lg5-prod-1314932667.cos.ap-nanjing.myqcloud.com/file%2Fjs%2Ffilerobot-image-editor.min.js',
};

export const getSuffixName = () => {
  const a = Number(Cookies.get(settings.systemTypeKey)) as ESystemType;

  const suffix = {
    [ESystemType.SAAS]: '平台',
    [ESystemType.Agent]: '代理商',
    [ESystemType.Company]: '企业',
    [ESystemType.Server]: '服务商',
  }[a];

  return suffix ? `-${suffix}` : '';
};

export const defaultMiniLogo = 'https://lg-test-1314932667.cos.ap-nanjing.myqcloud.com/pic/2/6008c81aef6548849d3ee15f4337ff89/Maskgroup@2x.png';
export const defaultLogo = 'https://lg-test-1314932667.cos.ap-nanjing.myqcloud.com/pic/2/d4b2fe08040c43deac20fd78b5094c43/login-logo.png';

export default settings;

